import AmplitudeUtils from '../../utils/amplitude-utils';
import {
  getOktaWidgetModel
} from '../../utils/widget-facade';
import BaseEnrollPhoneFactorCustomizer from './base';
export default class AuthenticatorEnrollmentDataCustomizer extends BaseEnrollPhoneFactorCustomizer {
  primaryButtonOnClick = () => {
    const authenticatorMethodType = getOktaWidgetModel().get('authenticator.methodType');
    const amplitudeEvent = authenticatorMethodType === 'voice' ? 'VoiceCall::CallButtonClick' : 'SMS::SendCodeButtonClick';
    AmplitudeUtils.logMfaEnrollEvent(amplitudeEvent);
  };

  private isLandingCompleted: boolean = false;

  async shouldCustomize() {
    return [ 'authenticator-enrollment-data' ].includes(this.context?.formName);
  }

  async customize() {
    await super.customize();
  }

  protected forgifyController() {
    if (!this.isLandingCompleted) {
      AmplitudeUtils.logMfaEnrollEvent('Phone::Landing');
      this.isLandingCompleted = true;
    }
    super.forgifyController();
    this.onMethodTypeChange();
  }

  private onMethodTypeChange() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const widgetModel = getOktaWidgetModel();
    widgetModel.once('change:authenticator.methodType', async function () {
      await self.customize();
    });
  }
}
